
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMembersRoom, getRoom } from '../../../../actions/userActions';
import AdminRoomRoot from '../../../../containers/ChatRooms/Room/Admin/Room/AdminRoom';
import localStorage from '../../../../utils/hooks/useLocalStorage';
import { useTokenCallback } from '../../../../utils/hooks/useTokenCallback';
import AdminGeneralRoom from './AdminGeneralRoom';

const RootAdminRoom = ({match,routes,history}) => {
  const {membersRoom,roomInfo} = useSelector(state=>state.userInfo)
  const dispatch = useDispatch()
  useTokenCallback(()=>{
    dispatch(getRoom(match.params.idRoom))
    dispatch(getMembersRoom(match.params.idRoom))
  },[match.params.idRoom])
  useEffect(() => {
    if(roomInfo._id){
      if(roomInfo.adminID !== localStorage().getItem("idProfile") && roomInfo.moderatorId !== localStorage().getItem('idProfile')){
        history.push("/Rooms")
      }
    }
  
    return () => {
      
    }
  }, [roomInfo])
  
  
  return <AdminRoomRoot isAdmin={roomInfo.adminID === localStorage().getItem("idProfile") } isLoading={!roomInfo._id  } membersRoom={membersRoom} roomInfo={roomInfo} routes={routes}/>;
};

export default RootAdminRoom;
